<template>
  <div class="flex justify-center">
    <div class="logo-lang flex items-center">
      <img src="@/assets/images/ico_lang.svg">

      <select
        id="lang"
        class="flex-1 ml-2 border border-gray-500 rounded h-8 text-sm text-gray-800 md:text-base"
        :value="userLang"
        @change="changeLang"
      >
        <option v-for="(val, key) in allowLangList" :key="key" :value="key">{{ val }}</option>
      </select>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { langList } from '@/core/i18n';

export default {
  name: 'LangSelector',
  data() {
    return {
      langList,
    };
  },
  computed: {
    ...mapState(['userLang', 'allowLang']),
    allowLangList() {
      let allowLangList = {};
      if (this.allowLang.length) {
        this.allowLang.forEach(lang => {
          allowLangList[lang] = this.langList[lang];
        });
      } else {
        allowLangList = this.langList;
      }

      return allowLangList;
    },
  },
  methods: {
    ...mapActions(['setLanguage']),
    changeLang(event) {
      this.setLanguage(event.target.value);
    },
  }
}
</script>

<style scoped>
.logo-lang {
  min-width: 200px;
}
</style>